import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { ICourse } from 'interfaces/learningPath'
import { AccessToCoursesEnum } from 'enum/accessToCourses'
import { useRolesAndPermissions } from '../../../../context/RolesAndPermissionsContext'
import { Description } from './styled'
import Options from './options'
import Courses from './courses'

interface IProps {
  close: () => void
}

const AddCourses = ({ close }: IProps) => {
  const { t } = useTranslation()
  const prefix = 'configuration.rolesAndPermissions.form.addCourses'
  const {
    roleDetail: data,
    setAccessToCourses: updateAccessToCourses,
    addCourses: appendCourses,
    removeAllCourses,
  } = useRolesAndPermissions()
  const [accessToCourses, setAccessToCourses] = useState(
    AccessToCoursesEnum.None
  )
  const [selectedCourses, setSelectedCourses] = useState<ICourse[]>([])

  useEffect(() => {
    setAccessToCourses(data.accessToCourses)
    setSelectedCourses([])
  }, [])

  const next = () => {
    updateAccessToCourses(accessToCourses)
    if (accessToCourses === AccessToCoursesEnum.Specific) {
      appendCourses(selectedCourses)
    } else {
      removeAllCourses()
    }
    close()
  }

  const changeOption = (value: AccessToCoursesEnum) => {
    setAccessToCourses(value)
    setSelectedCourses([])
  }

  return (
    <Modal
      isOpen={true}
      title={t(`${prefix}.title`)}
      maxwidth={800}
      maxheight={660}
      close={close}
      actions={
        <ModalButtons
          primaryText={t(`${prefix}.actions.select`)}
          primaryAction={next}
          secondaryText={t(`${prefix}.actions.cancel`)}
          secondaryAction={close}
          disablePrimaryButton={
            accessToCourses === AccessToCoursesEnum.Specific &&
            selectedCourses.length === 0
          }
        />
      }
    >
      <>
        <Description>{t(`${prefix}.description`)}</Description>
        <Options activeOption={accessToCourses} changeOption={changeOption} />
        {accessToCourses === AccessToCoursesEnum.Specific && (
          <Courses
            selectedCourses={selectedCourses}
            setSelectedCourses={setSelectedCourses}
          />
        )}
      </>
    </Modal>
  )
}

export default AddCourses
